module.exports = __webpack_public_path__ + "img/print.cec691ad.gif";